module.exports = __webpack_public_path__ + "static/image1-bfe908b99fb4cc93bae746c2320ee2a6.jpg";